<div class="flex flex-col h-full in-progress-page">
  <m-layout class="flex flex-col h-full">
    <div #navbarContent navbar-content>
      <div class="flex justify-between items-center h-full">
        <span class="h4 text-orange-300 mb-0">Welcome, {{ name }}</span>
        <m-button type="secondary" (click)="navigateToSupportPage()"
          >Learn more</m-button
        >
      </div>
    </div>

    <div main-content class="flex flex-col h-full">
      <div class="flex flex-col justify-center items-center h-full">
        <m-empty-states
          [size]="EmptyStateSize.intermediate"
          title="We're still working on this!"
          description="Contact your customer success partner to see how it's coming along."
          [stateType]="EmptyStateType.dataProcessing">
        </m-empty-states>
      </div>
    </div>
  </m-layout>
</div>
